import { API_URL, WEB_URL } from '../constant/API_Settings';

function backendBaseUrl() {
  return (WEB_URL || 'http://127.0.0.1:8000').replace(/\/+$/, '');
}

function buildLegacyAccessUrl(accessToken) {
  return `${backendBaseUrl()}/legacy-reports/access/${encodeURIComponent(accessToken)}`;
}

/**
 * Fetch token for legacy-reports portal; URL is built with frontend WEB_URL (correct port in dev).
 */
export async function fetchLegacyReportsCatalogUrl() {
  const authToken = localStorage.getItem('AUTH_TOKEN');
  if (!authToken) {
    return null;
  }

  try {
    const response = await fetch(`${API_URL}/legacy-reports/access-url`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${authToken}`,
      },
    });

    if (!response.ok) {
      return null;
    }

    const data = await response.json();
    if (data?.status !== true) {
      return null;
    }

    if (data.access_token) {
      return buildLegacyAccessUrl(data.access_token);
    }

    return data.catalog_url || null;
  } catch {
    return null;
  }
}

/**
 * Open the legacy Blade reports catalog in a new browser tab.
 * Opens a blank tab synchronously first so popup blockers do not block the window.
 *
 * Do not pass "noopener" to window.open — modern browsers then return null for the
 * window handle while still leaving an orphan about:blank tab, and the fallback
 * navigates the current dashboard tab instead.
 */
export async function openLegacyReportsPortal() {
  const pendingTab = window.open('about:blank', '_blank');

  try {
    if (pendingTab && pendingTab.document) {
      pendingTab.document.title = 'Opening Legacy Reports…';
      pendingTab.document.body.innerHTML = '<p style="font-family:sans-serif;padding:1.5rem;color:#555;">Opening Legacy Reports…</p>';
    }
  } catch {
    // Cross-origin / blocked document access — still navigate via location below.
  }

  const catalogUrl = await fetchLegacyReportsCatalogUrl();

  if (catalogUrl) {
    if (pendingTab) {
      try {
        pendingTab.opener = null;
      } catch {
        // ignore
      }
      pendingTab.location.href = catalogUrl;
    } else {
      // Popup blocked — stay in this tab rather than leaving a blank orphan tab.
      window.location.href = catalogUrl;
    }
    return true;
  }

  if (pendingTab) {
    pendingTab.close();
  }

  window.alert(
    'Could not open Legacy Reports. Ensure you are logged in and Laravel is running on port 8000.'
  );

  return false;
}
